const promptBeforeUnload = (event: BeforeUnloadEvent): void => {
  // Cancel the event.
  event.preventDefault();
  // Chrome (and legacy IE) requires returnValue to be set.
  event.returnValue = '';
};

export default promptBeforeUnload;
